import { Link } from "react-router-dom";

const LINKS = [
  { to: "/cgu", label: "CGU" },
  { to: "/cgv", label: "CGV" },
  { to: "/reglement", label: "Règlement des défis" },
  { to: "/confidentialite", label: "Confidentialité" },
  { to: "/cookies", label: "Cookies" },
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/contact", label: "Contact" },
  { to: "/donnees-personnelles", label: "Données personnelles" },
];

export default function LegalFooter() {
  return (
    <footer
      data-testid="legal-footer"
      className="relative z-10 border-t border-white/5 mt-10 pb-[calc(env(safe-area-inset-bottom)+5rem)] sm:pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <nav
          aria-label="Liens légaux"
          className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] uppercase tracking-widest font-mono-stat text-white/45"
        >
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`legal-link-${l.to.slice(1)}`}
              className="hover:text-cyan-300 transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="mt-5 flex items-center justify-between text-[10px] uppercase tracking-widest font-mono-stat text-white/30">
          <div className="flex items-center gap-2">
            <div
              data-testid="footer-otra-logo"
              aria-hidden="true"
              className="w-6 h-6 shrink-0"
              style={{
                backgroundImage: 'url("/assets/otra-logo.png")',
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                filter: "drop-shadow(0 0 8px rgba(0, 229, 255, 0.5))",
              }}
            />
            <span>OTRAQUIZZ · 2026</span>
          </div>
          <span>Powered by Emergent</span>
        </div>
      </div>
    </footer>
  );
}
